import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import styles from "./style.module.css";
import trash from "../../../../../assets/images/trash-icons/trash-03.svg";
import { useTheme } from "../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateDelete } from "../../../../../store/slices/infoSlice";
import { checkPrimarySkill } from "../../../../../helpers/checkPrimarySkill";
import checkProfileComplete from "../../../../../helpers/checkProfileComplete";
import {
  setActiveUserSkill,
  setUser,
  setUserSkills,
  setCommunityStatus as setUserStatus,
} from "../../../../../store/slices/userSlice";
import { setPage } from "../../../../../store/slices/profile/discoverSlice";
import useSettings from "../../../../../hooks/useSettings";
import axios from "axios";
import { node_server } from "../../../../../constants";
import generateFeeds from "../../../../../helpers/generateFeeds";
import { setIsPageLoading } from "../../../../../store/slices/loadingSlice";

const DeleteConfirmation = () => {
  const { theme, darkMode } = useTheme();
  const { isDeleteOpen } = useSelector((state) => state.info.delete);
  const dispatch = useDispatch();

  const {
    value: user,
    userSkills,
    activeUserSkill,
    communityStatus: userStatus,
    collaboratorsTypes,
  } = useSelector((state) => state.user);
  const { recalculateScore } = useSettings();

  const handleClose = () => {
    dispatch(updateDelete({ isDeleteOpen: false }));
  };

  const handleDeleteSkill = async () => {
    dispatch(setIsPageLoading(true));
    const id = activeUserSkill?.id;
    const { data, error } = await axios.delete(
      `${node_server}/api/skills`,
      {
        params: { id },
        withCredentials: true,
      }
    );

    if (error) console.error(error);
    if (data) {
      dispatch(setActiveUserSkill(null));
      const updatedSkills = userSkills.map((skill) => {
        if (skill.id !== id) {
          if (skill.id === data.altPrimarySkillId)
            return { ...skill, isPrimary: true };
          else return skill;
        } else return null;
      });
      dispatch(setUserSkills(updatedSkills));
      // await checkPrimarySkill({
      //   updatedSkills,
      //   setUserSkills: (value) => dispatch(setUserSkills(value)),
      // });
    }

    const userState = { user, setUser: (value) => dispatch(setUser(value)) };
    const statusState = {
      status: userStatus,
      setStatus: (value) => dispatch(setUserStatus(value)),
    };

    await checkProfileComplete(
      userState,
      statusState,
      userSkills,
      collaboratorsTypes
    );

    dispatch(updateDelete({ isDeleteOpen: false }));
    dispatch(setIsPageLoading(false));

    if (user.isProfileComplete) {
      const feedResponse = await generateFeeds(user);

      if (feedResponse === "User feed generated") {
        dispatch(setPage(1));
      }
    }

    recalculateScore();
  };

  return (
    <Modal open={isDeleteOpen} onClose={handleClose}>
      <Box
        className={styles.delConfirm}
        sx={{
          width: {
            xs: "320px",
            sm: "360px",
          },
          bgcolor: theme.palette.lightgrey.lightgrey00,
        }}
      >
        <Box className={styles.content}>
          <Box className={styles.frame}>
            <Box className={styles.icon}>
              <img src={trash} alt="delete" />
            </Box>
            <Box className={styles.text}>
              <Typography
                variant="body1"
                component="h4"
                sx={{
                  color: theme.palette.darkgrey.darkgrey600,
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                Do you want delete this skill?
              </Typography>
            </Box>
          </Box>
          <Box className={styles.buttons}>
            <Button
              variant="text"
              onClick={handleClose}
              sx={{
                color: theme.palette.darkgrey.darkgrey300,
                bgcolor: darkMode
                  ? "#3D3D3D"
                  : theme.palette.lightgrey.lightgrey500,
                padding: "8px",
                boxShadow: "none",
                width: "120px",
                fontSize: "16px",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                color: "#FFF",
                bgcolor: theme.palette.danger.red500,
                padding: "8px",
                width: "120px",
                fontSize: "16px",
                textTransform: "capitalize",
              }}
              onClick={handleDeleteSkill}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default DeleteConfirmation;
